'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import type { CreateCharacterInput, Character } from '../types';

export async function updateCharacter(
  characterId: string,
  input: Partial<CreateCharacterInput>,
): Promise<ActionResult<Character>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const { CharacterService } = await import('@/contexts/characters/services/CharacterService');
    const updated = await CharacterService.updateCharacter({
      characterId,
      familyId,
      updates: {
        name: input.name,
        role: input.role ?? undefined,
        gender: input.gender ?? undefined,
        age: input.age ?? undefined,
        physicalDescription: input.physicalDescription ?? undefined,
        personalityTraits: input.personalityTraits ?? undefined,
        specialAbilities: input.specialAbilities ?? undefined,
        synonyms: input.synonyms ?? undefined,
      },
    });

    return { success: true, data: updated as Character };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('updateCharacter', e) };
  }
}
